import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersAdminService } from '../services/users-admin.service';
import { LaunchpadUser } from '../models/launchpad-user';

@Component({
    selector: 'app-delete-user-modal',
    templateUrl: './delete-user-modal.component.html',
    styleUrls: ['./delete-user-modal.component.sass'],
    standalone: false
})
export class DeleteUserModalComponent {

  /** Reason the modal is dismissed with when the deletion failed and the user is left pending deletion */
  static readonly DeletionFailedReason = 'deletionFailed';

  @Input({ required: true }) user!: LaunchpadUser;

  confirmationEmail: string = '';
  submitting: boolean = false;
  error: boolean = false;

  /** Deletion is permanent, so the admin has to type the user's email address to confirm it */
  get confirmed(): boolean {
    return this.confirmationEmail.trim().toLowerCase() === this.user.emailAddress.toLowerCase();
  }

  constructor(protected activeModal: NgbActiveModal,
              private userAdminService: UsersAdminService) {
  }

  confirmDeletion(): void {
    if (!this.confirmed || this.submitting) {
      return;
    }

    this.submitting = true;
    this.error = false;
    this.userAdminService.deleteUser(this.user.emailAddress).subscribe({
      next: () => {
        this.submitting = false;
        this.activeModal.close();
      },
      error: () => {
        this.submitting = false;
        this.error = true;
      }
    });
  }

  cancel(): void {
    this.activeModal.dismiss(this.error ? DeleteUserModalComponent.DeletionFailedReason : undefined);
  }
}
